module.exports = __webpack_public_path__ + "static/media/logo-part-1.528e3376.svg";